import { IReduxStore } from "Redux/Store/IReduxStore";

export const getTag = (state: IReduxStore, id: number|string) => state.tag.tag.entries[id];
